import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import {AgentModel} from "../../angular/models/agent.model";
import {ItineraryModel} from "../../../itineraries/angular/models/itinerary.model";
import {TaskModel} from "../../../tasks/models/task.model";
import {LogisticsVehicle} from "../../../logistics-vehicle/models/logistics-vehicle.model";
import {Subscription} from "rxjs";
import {ItinerariesService} from "../../../itineraries/services/itineraries-service.service";
import {AgentRequests} from "../../services/agent-requests.service";
import {AgentsService} from "../../services/agents-service.service";
import {ResizeService} from "../../../commons/services/resize-service.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {LogisticsVehicleService} from "../../../logistics-vehicle/services/logistics-vehicle-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {
  LogisticsVehiclesDialogsService
} from "../../../logistics-vehicle/services/logistics-vehicles-dialogs-service.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {RoutesService} from "../../../routes/services/routes-service.service";
import {LocationsFacadeService} from "../../../commons/angular/services/locations/locations-facade.service";
import {ItinerariesFacadeService} from "../../../itineraries/angular/services/itineraries-facade.service";
import * as moment from "moment";
import * as _ from "lodash";
import {TasksFacadeService} from "../../../tasks/angular/services/tasks-facade.service";
import {LocationModel} from "../../../commons/models/location.model";
import {LocationHolderType} from "../../../commons/types/locationHolder.type";
import {TaskStatusType} from "../../../tasks/types/taskStatus.type";
import {TasksHttpService} from "../../../tasks/angular/services/tasks-http.service";

export class AgentItineraryViewNewComponent implements IController {

  agent: AgentModel;
  agentConfigurationProfile: any;
  showAgentInfo: any;
  onAgentSelect: Function;
  onClose: Function;

  // private tasksRef: any;
  public showMap: boolean;
  public inActiveStatuses: any;
  public completedStatuses: any;
  public itineraryTasks: TaskModel[];
  public tasksByGroup: TaskModel[];
  public itinerary: ItineraryModel;
  public relatedItineraries: ItineraryModel[];
  public itineraryTotals: any;
  public relatedTasks: TaskModel[];
  public hiddenAgentIds: string[];
  public relatedCompletedTasks: TaskModel[];
  public isEditMode: boolean;
  public highlightedServiceId: any;
  public editModeHasItineraryChanged: boolean;
  public highlightedTaskId: any;
  public isExpandedTasks: boolean;
  public inActiveTasksDateQuery: any;
  public selectedTasksGroup: any;
  public userNameId: string;
  // public agentServiceAreas: any;
  public serviceAreasPolygons: any;
  public itineraryAgentId: string;
  public serviceAreasRef: any;
  public logisticsVehicles: LogisticsVehicle[];
  public attachedLogisticsVehicles: LogisticsVehicle[];
  public hasLogisticsVehiclePermission: boolean;
  public completedRouteTasksData: any;
  public pushesTimeoutRef: any;
  public maxUserIdleTimeMinutes: number;
  public selectLocationsSubscription: Subscription;
  public locationIds: string[];
  public itinerariesSubscription: Subscription;
  public tasksSubscription: Subscription;
  public itineraryAbortedTasks: TaskModel[];
  public itineraryCompletedTasks: TaskModel[];
  public taskStatusTypes: typeof TaskStatusType = TaskStatusType;


  constructor(private itinerariesService: ItinerariesService, private agentRequests: AgentRequests, private agentsService: AgentsService, private $task,
              private resizeService: ResizeService, private IAMPermissions, private commonsService: CommonsService, private logisticsVehicleService: LogisticsVehicleService,
              private commonsDialogService: CommonsDialogService, private logisticsVehiclesDialogsService: LogisticsVehiclesDialogsService, private splitService: SplitService,
              private itinerariesConstant, private $timeout: ITimeoutService, private UserService, private $serviceArea, private routesService: RoutesService,
              private $q, private locationsFacadeService: LocationsFacadeService, private itinerariesFacadeService: ItinerariesFacadeService,
              private tasksFacadeService: TasksFacadeService, private tasksHttpService: TasksHttpService) {
  }

  $onInit() {
    this.hasLogisticsVehiclePermission = this.IAMPermissions.hasPermission('vehicleInstance.logisticsVehicle.list');
    this.maxUserIdleTimeMinutes = this.splitService.maxUserIdleTimeMinutes();
    this.userNameId = this.UserService.getCurrentUser().id; // Current admin user id.

    this.serviceAreasRef = this.$serviceArea();
    this.inActiveStatuses = this.itinerariesConstant.inActiveTaskStatuses;
    this.completedStatuses = this.itinerariesConstant.completedTaskStatuses;

    this.itineraryTotals = {};
    this.relatedTasks = [];
    this.hiddenAgentIds = [];

    this.tasksByGroup = [];
    this.itineraryTasks = [];
    this.itineraryAbortedTasks = [];
    this.itineraryCompletedTasks = [];
    this.relatedCompletedTasks = [];
    this.attachedLogisticsVehicles = [];
    this.isEditMode = false;
    this.editModeHasItineraryChanged = false;
    this.isExpandedTasks = true;
    this.inActiveTasksDateQuery = moment().toDate();
    this.selectedTasksGroup = 'Active';
    this.serviceAreasPolygons = undefined;

    // this._setAgentItineraryId(this.agent);

    this._getAgentServiceAreas(_.get(this.agent, 'agentPreferencesReference.priorityServiceAreas', []));

    this._initItinerary();
    this.itinerariesFacadeService.subscribeToChannels();
    this.tasksFacadeService.subscribeToChannels();

    this.commonsService.bindUserEvents((event) => {
      if (!!this.pushesTimeoutRef) {
        this._initPushesTimer();
      }
    })

    this._initPushesTimer();


    this._setLocations();

    this.selectLocationsSubscription = this.locationsFacadeService.selectLocations()
      .subscribe((locations) => {
        const attachedLogisticsVehiclesCopy = angular.copy(this.attachedLogisticsVehicles);
        _.forEach(locations, (updatedLocation: LocationModel) => {
          if (updatedLocation.holder === LocationHolderType.LogisticsVehicle) {
            const logisticsVehicleIndex = _.findIndex(this.attachedLogisticsVehicles, (v) => {
              return v.id === updatedLocation.holderId;
            })

            if (logisticsVehicleIndex > -1) {
              attachedLogisticsVehiclesCopy[logisticsVehicleIndex].coordinates = updatedLocation.coordinates;
            }
          }

          if (updatedLocation.holder === LocationHolderType.Agent) {
            if (_.get(this.agent, 'id') === _.get(updatedLocation, 'holderId')) {
              const agentCopy = angular.copy(this.agent);
              agentCopy.lastKnownLocation = updatedLocation;
              this.agent = agentCopy;
            }
          }
        })

        this.attachedLogisticsVehicles = attachedLogisticsVehiclesCopy;

        // Update Angularjs Cycle
        this.$timeout(0).then(() => {
        });
      });

    this.itinerariesSubscription = this.itinerariesFacadeService.selectAll().subscribe(itineraries => {

      const agentItinerary = itineraries.find(i => i.id === this.itineraryAgentId);
      if (!agentItinerary) {
        this.itinerary = undefined;
        return;
      }
      this.itinerary = agentItinerary;
      this._setRelatedItineraries(agentItinerary);

      const relatedAgentItineraries = itineraries.filter(i => !!this.itinerary.relatedAgentIds?.includes(i.id));
      this.relatedItineraries = relatedAgentItineraries || [];

      this._setRelatedTasks(this.relatedItineraries);

      this.editModeHasItineraryChanged = this.isEditMode;

      // Agent Itinerary Update
      if (!this.isEditMode) {
        this._updateTotals(this.itinerary);

        this._setTasks();

        this.getInactiveTasks();
      }

      this.$timeout(0).then(() => {
      });
    })

    this.tasksSubscription = this.tasksFacadeService.selectAll().subscribe(tasks => {

      this.relatedTasks = _.uniqBy((tasks?.filter(t => !!_.flatMap(this.relatedItineraries, 'taskIdListExt').includes(t.id)) || [])
        .concat(this.relatedCompletedTasks), 'id');

      const activeTaskIds = (this.isExpandedTasks ? this.itinerary?.taskIdListExt : this.itinerary?.taskIdList) || [];

      this.itineraryTasks = tasks?.filter(t => !!activeTaskIds?.includes(t.id)) || [];
      this.itineraryTasks.sort((a, b) => {
        return activeTaskIds.indexOf(a.id) - activeTaskIds.indexOf(b.id);
      })
      // this._updateTotals(this.itinerary);

      this.tasksByGroup = this._filterTasksByGroup(this.selectedTasksGroup);
      this._setRelatedCompletedTasks(this.itineraryTasks.concat(this.itineraryAbortedTasks).concat(this.itineraryCompletedTasks));

      this.$timeout(0).then(() => {
      });
    })


  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.agent && !changes.agent.isFirstChange()) {
      this.completedRouteTasksData = undefined;

      const currentAgent = changes.agent.currentValue;
      const previousAgent = changes.agent.previousValue;

      if (!_.isEqual(_.get(currentAgent, 'id'), _.get(previousAgent, 'id'))) {
        this.selectedTasksGroup = 'Active';
        this.inActiveTasksDateQuery = moment().toDate();
        if (this.isEditMode) {
          this.isEditMode = false;
          this.editModeHasItineraryChanged = false;
        }
        this.highlightedServiceId = undefined;
        this._getAgentServiceAreas(_.get(currentAgent, 'agentPreferencesReference.priorityServiceAreas', []));
        this._initItinerary();

        this.locationsFacadeService.removeLocationsByIds(this.locationIds);
        this._setLocations();
      }
      if (!_.isEqual(currentAgent.itineraryInfo.taskIdListExt, previousAgent.itineraryInfo.taskIdListExt)) {
        if (this.isEditMode) {
          this.editModeHasItineraryChanged = true;
        }
      }
    }
  }

  $onDestroy() {
    if (_.isEqual(_.get(this.agent, 'itineraryInfo.itineraryEditLockedByAdmin'), this.userNameId)) {
      this.agentRequests.editItineraryUnlock(this.itineraryAgentId);
    }
    this._clearAllCurrentItineraryRefs();

    this.locationsFacadeService?.removeAllLocations();
    this.selectLocationsSubscription?.unsubscribe();

    this.itinerariesSubscription?.unsubscribe();
    this.itinerariesFacadeService?.unsubscribeFromChannels();

    this.tasksSubscription?.unsubscribe();
    this.tasksFacadeService?.unsubscribeFromChannels();

  };

  onToggleMap() {
    this.showMap = !this.showMap;
    this.$timeout(0).then(() => {
      this.resizeService.resize();
    })
  };

  onHighlightedChanged(serviceId, highlightedTaskId) {
    this.highlightedServiceId = serviceId;
    this.highlightedTaskId = highlightedTaskId;
  }

  toggleTasksExpanded() {
    this.isExpandedTasks = !this.isExpandedTasks;
    // this.tasksFacadeService.removeByIds(this.itineraryTasks.map(t => t.id));
    this._setTasks();
  }

  onToggleAssistantItinerary() {
    const itineraryAgentIdToSelect = this.itineraryAgentId === this.agent.id ?
      _.get(this.agent, 'mainAgentIds[0]') :
      _.get(this.agent, 'id');
    this._initItinerary(itineraryAgentIdToSelect);
  }

  onItineraryTasksTabSelect(group) {
    if (!_.isEqual(this.selectedTasksGroup, group)) {
      this.completedRouteTasksData = undefined;
      this.selectedTasksGroup = group;

      this.tasksByGroup = this._filterTasksByGroup(this.selectedTasksGroup);

      this.$timeout(() => {
      }, 0)

      if (group !== 'Active') {
        this.getInactiveTasks();
      }
    }
  }

  onInactiveTasksDateChange(date) {
    this.inActiveTasksDateQuery = moment(date).toDate();

    this.getInactiveTasks();
  }

  onToggleEdit() {
    this.isEditMode = !this.isEditMode;

    if (this.isEditMode) {
      this.selectedTasksGroup = 'Active';
    }

    this.tasksByGroup = this._filterTasksByGroup(this.selectedTasksGroup);

    this.$timeout(() => {
    }, 0)
  }

  updateEditModeTasksOrder(taskIds) {
    this.itineraryTasks = _.map(taskIds, (id) => {
      return _.find(this.itineraryTasks, (t) => {
        return t.id === id;
      })
    })
    this.tasksByGroup = this._filterTasksByGroup(this.selectedTasksGroup);
    this.$timeout(() => {
    }, 0)
  }

  onToggleAgent(agentId) {
    const isEnabled = !_.includes(this.hiddenAgentIds, agentId);
    if (isEnabled) {
      this.hiddenAgentIds = this.hiddenAgentIds.concat([agentId]);
    } else {
      this.hiddenAgentIds = _.filter(this.hiddenAgentIds, (id) => {
        return id !== agentId;
      })
    }
  }

  onHiddenAgentIdsChange(agentIds) {
    this.hiddenAgentIds = agentIds;
  }

  onBindVehicle() {
    this.logisticsVehiclesDialogsService.availableLogisticVehiclesForBinding(this.agent.branchIds, this.attachedLogisticsVehicles)
      .then((logisticsVehicles) => {
        this._bindLogisticsVehiclesToAgent(this.agent.id, _.map(logisticsVehicles, 'id'), true);
      });
  }

  onUnbindVehicle() {
    this.logisticsVehicleService.unbindVehicle(this.agent.id)
      .then((res) => {
        this.attachedLogisticsVehicles = [];
      });
  }

  onSendNotificationToAgent(agentPnType: string) {
    this.agentsService.sendNotification(agentPnType, [this.agent.id]);
  }


  onUpdateItinerary(itinerary) {
    this.agentsService.editItinerarySettings(this.itineraryAgentId, itinerary)
      .then((updatedItinerary) => {
        this.itinerariesFacadeService.setOne(updatedItinerary);
      })
  }

  saveEditItinerary(taskIds) {
    this.agentsService.saveEditItinerary(this.itineraryAgentId, taskIds)
      .then((itinerary: ItineraryModel) => {
        this.isEditMode = false;
        this.editModeHasItineraryChanged = false;
        this.itinerariesFacadeService.setOne(itinerary);
      })
  }

  onResetItinerary() {
    this.agentsService.resetItinerary(this.itineraryAgentId)
      .then((itinerary) => {
        this.isEditMode = false;
        this.editModeHasItineraryChanged = false;
        this.itinerariesFacadeService.setOne(itinerary);
      })
  }

  updateItineraryEditMode(taskIds) {
    this.agentsService.checkEditItinerary(this.itineraryAgentId, taskIds)
      .then((updatedEditItinerary: any) => {
        this.tasksByGroup = updatedEditItinerary.taskListExt;
        this.$timeout(() => {
        }, 0)
      })
  }

  private _bindLogisticsVehiclesToAgent(agentId: string, logisticsVehicleIds: string[], forceUnbind?: boolean) {
    this.logisticsVehicleService.bindToAgent(agentId, logisticsVehicleIds, forceUnbind)
      .then((res) => {
        this._getAgentLogisticsVehicles(this.agent);
      });
  }

  private _getAgentServiceAreas(serviceAreaIds) {
    if (serviceAreaIds.length) {
      this.serviceAreasRef.$asyncValues(serviceAreaIds)
        .then((serviceAreas) => {
          this.serviceAreasPolygons = serviceAreas;
        })
    } else {
      this.serviceAreasPolygons = [];
    }
  }

  private _getAgentLogisticsVehicles(agent) {
    this.attachedLogisticsVehicles = [];

    this.logisticsVehicleService.getCurrentBoundedByAgent(agent.id)
      .then((attachedLogisticsVehicles) => {
        this.attachedLogisticsVehicles = attachedLogisticsVehicles;
        if (attachedLogisticsVehicles.length) {
          const payload = _.map(attachedLogisticsVehicles, (v) => {
            return {
              holderId: v.id,
              holder: LocationHolderType.LogisticsVehicle
            }
          })
          this.locationsFacadeService.getLocations(payload);
        }
      })
  }


  private _initItinerary(itineraryAgentIdToSelect?) {

    this._clearAllCurrentItineraryRefs();
    this._setAgentItineraryId(this.agent, itineraryAgentIdToSelect);

    this.itinerariesFacadeService.getMany([this.itineraryAgentId], true);

    // this.getInactiveTasks();
  }

  private getInactiveTasks() {
    this.itinerariesService.getInActiveTasks(this.itineraryAgentId, moment(this.inActiveTasksDateQuery).valueOf())
      .then((inactiveTasks) => {
        this.itineraryAbortedTasks = inactiveTasks.filter(t => t.status === this.taskStatusTypes.Canceled)
        this.itineraryCompletedTasks = inactiveTasks.filter(t => t.status === this.taskStatusTypes.CourierDeparted || t.status === this.taskStatusTypes.ManualHandled);

        this._updateTotals(this.itinerary);
        this.tasksByGroup = this._filterTasksByGroup(this.selectedTasksGroup);

        if (this.selectedTasksGroup === 'Completed') {
          const taskLocations = _.flatMap(inactiveTasks, 'taskSpec.address.location');
          if (taskLocations.length > 1) {
            this.getCompletedRouteTasksData(taskLocations);
          }
        }

        this.$timeout(() => {
        }, 0);
      })
  }

  private _setTasks() {

    let oldItineraryActiveTasks = this.itineraryTasks?.map(t => t.id) || [];
    let newItineraryActiveTasks = (this.isExpandedTasks ? this.itinerary.taskIdListExt : this.itinerary.taskIdList) || [];

    const taskIdsToAdd = _.difference(newItineraryActiveTasks, oldItineraryActiveTasks);
    const taskIdsToRemove = _.difference(oldItineraryActiveTasks, newItineraryActiveTasks);


    if (!!taskIdsToRemove.length) {
      this.tasksFacadeService.removeByIds(taskIdsToRemove);
    }

    if (!!taskIdsToAdd.length) {
      this.tasksFacadeService.getByIds(taskIdsToAdd);
    }

    this._updateTotals(this.itinerary);
  }

  private _setRelatedItineraries(itinerary) {
    const relatedAgentIdsItinerariesToAdd = _.difference(itinerary.relatedAgentIds, _.map(this.relatedItineraries || [], 'id'));
    const relatedAgentIdsItinerariesToRemove = _.difference(_.map(this.relatedItineraries || [], 'id'), itinerary.relatedAgentIds);


    if (!!relatedAgentIdsItinerariesToRemove.length) {
      this.itinerariesFacadeService.removeByIds(relatedAgentIdsItinerariesToRemove);
    }

    if (!!relatedAgentIdsItinerariesToAdd.length) {
      this._setRelatedItinerariesByAgentIds(relatedAgentIdsItinerariesToAdd);
    }
  }

  private _setRelatedCompletedTasks(tasks: TaskModel[]) {

    let completedRelatedTaskIds = [];
    _.forEach(tasks, (t) => {
      if (_.get(t, 'relations.length', false)) {
        let completedTaskIds = _.chain(t.relations)
          .filter((r) => {
            return _.get(r, 'details.status') === "CourierDeparted";
          })
          .map((filteredRelation) => {
            return filteredRelation.relatedTaskId;
          })
          .value();

        completedRelatedTaskIds = completedRelatedTaskIds.concat(completedTaskIds || []);
      }
    })

    this.relatedCompletedTasks = [];

    if (!!completedRelatedTaskIds?.length) {
      this.tasksHttpService.getTasks(completedRelatedTaskIds)
        .subscribe((relatedCompletedTasks) => {
          this.relatedCompletedTasks = relatedCompletedTasks;
          this.relatedTasks = _.uniqBy(this.relatedTasks.concat(relatedCompletedTasks), 'id');
        })
    }
  }

  private _filterTasksByGroup(group) {
    switch (group) {
      case 'All':
        return (this.itineraryAbortedTasks.concat(this.itineraryCompletedTasks)).concat(this.itineraryTasks);
      case 'Completed':
        return this.itineraryCompletedTasks;
      case 'Aborted':
        return this.itineraryAbortedTasks
      case 'Active':
        return this.itineraryTasks;
      default:
        return []
    }
  }

  private _updateTotals(itinerary) {
    if (itinerary) {
      let totals = angular.copy(_.get(itinerary, 'totals', {}));

      const activeTaskIds = this.isExpandedTasks ? (itinerary.taskIdListExt || []) : (itinerary.taskIdList || []);

      totals.activeTasksCount = activeTaskIds.length || 0;
      totals.aborted = this.itineraryAbortedTasks.length;
      totals.completed = this.itineraryCompletedTasks.length;
      totals.allTasksCount = activeTaskIds.length + totals.aborted + totals.completed;
      this.itineraryTotals = totals;
    }
  }

  private _setAgentItineraryId(agent, itineraryAgentIdToSelect?) {
    this.itineraryAgentId = itineraryAgentIdToSelect || _.get(agent, 'id') || _.get(agent, 'mainAgentIds[0]');
  }

  private _clearAllCurrentItineraryRefs() {
    this.itineraryTotals = {};
    this.hiddenAgentIds = [];
    this._resetAgentItinerary();
  }

  private _resetAgentItinerary() {
    if (!!this.itinerary) {
      this.itinerariesFacadeService.removeAll();
    }
    if (!!this.itineraryTasks) {
      this.tasksFacadeService.removeAll();
    }
    this.$timeout(() => {
    }, 0)
  }

  private _setLocations() {
    this.locationIds = [];
    this.locationIds.push(this.agent.id);
    let payload = [{holderId: this.agent.id, holder: LocationHolderType.Agent}];

    if (!!this.hasLogisticsVehiclePermission) {
      this.logisticsVehicleService.getCurrentBoundedByAgent(this.agent.id)
        .then((logisticsVehicles) => {
          this.attachedLogisticsVehicles = logisticsVehicles;
          logisticsVehicles.forEach(logisticVehicle => {
            this.locationIds.push(logisticVehicle.id);
            payload.push({
              holderId: logisticVehicle.id,
              holder: LocationHolderType.LogisticsVehicle
            })
          })
          this.locationsFacadeService.getLocations(payload);
        });
    } else {
      this.locationsFacadeService.getLocations(payload);
    }
  }

  private _setRelatedItinerariesByAgentIds(relatedAgentIds) {
    this.itinerariesFacadeService.getMany(relatedAgentIds, true);
    this.hiddenAgentIds = relatedAgentIds;
  }

  private _setRelatedTasks(relatedItineraries: ItineraryModel[]) {

    let relatedTaskOldIds = this.relatedTasks.map(relatedTask => relatedTask.id);
    let relatedTaskIds = _.flatMap(relatedItineraries, 'taskIdListExt');

    if (_.isUndefined(relatedTaskIds)) {
      relatedTaskIds = [];
    }

    if (!relatedTaskOldIds) {
      relatedTaskOldIds = [];
    }

    const taskIdsToAdd = _.difference(relatedTaskIds, relatedTaskOldIds);
    const taskIdsToRemove = _.difference(relatedTaskOldIds, relatedTaskIds);

    if (!!taskIdsToRemove.length) {
      this.tasksFacadeService.removeByIds(taskIdsToRemove);
    }

    if (!!taskIdsToAdd.length) {
      this.tasksFacadeService.getByIds(taskIdsToAdd);
    }
  }

  private getCompletedRouteTasksData(taskLocations) {
    this.routesService.getRouteTasksData(taskLocations)
      .then((res: any) => {
        this.completedRouteTasksData = res;
        this._updateTotals(this.itinerary);
      })
  }

  private _initPushesTimer() {
    this._destroyPushesTimer();

    this.pushesTimeoutRef = this.$timeout(() => {
      this.$timeout.cancel(this.pushesTimeoutRef);
      this.pushesTimeoutRef = undefined;

      this.commonsDialogService.stillThereConfirm()
        .then((continueSession) => {
          if (continueSession) {
            this._initPushesTimer();

            //Sync Tasks/Itinerary
            this._initItinerary();
          }
        })
    }, (this.maxUserIdleTimeMinutes * 60000));
  }

  private _destroyPushesTimer() {
    if (this.pushesTimeoutRef) {
      this.$timeout.cancel(this.pushesTimeoutRef);
      this.pushesTimeoutRef = undefined;
    }
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentItineraryViewNew', {
    bindings: {
      agent: '<',
      agentConfigurationProfile: '<',
      showAgentInfo: '<',
      onAgentSelect: '&',
      onClose: '&?'
    },
    template: require('./agent-itinerary-view-new.html').default,
    controller: AgentItineraryViewNewComponent
  });
